/* eslint no-restricted-syntax: 0 */
/* eslint no-await-in-loop: 0 */
/* eslint no-else-return: 0 */
/* eslint no-param-reassign: 0 */
import * as tfcore from '@tensorflow/tfjs-core';
import * as tf from '@tensorflow/tfjs';
import {
  setBackendAndEnvFlags,
  normalizePlain,
  flatOneHot,
  fisherYates,
  convertToTfDataset,
  convertBase64ToObject,
  convertObjectToBase64,
  preprocessText,
  shuffleWithSeed,
  uint8ToString,
} from '@utils/hooks/machineLearning/util'
import { STATE, MODEL_TYPES } from '../params';


export default class TextsHandler {
  modelType = MODEL_TYPES.TEXTS;

  importModelApi = STATE.importModelApi;

  minSamplesRequired = {
    samples: 7,
    classes: 2,
  };

  trainingParams = {
    denseUnits: 128,
    epochs: 50,
    fineTunningEpochs: -1,
    learningRate: 0.01,
    batchSize: 4,
  };

  wrapper = null;

  classifying = false;

  predictionCallback = null;

  model = null;

  samples = {
    class0: {
      index: 0,
      name: '',
      image: [],
      active: true,
      tensors: [],
    },
  };

  trainDataset = null;

  labelDataset = null;

  classWeights = {};

  classNamesToIndex = {};

  rafId = null;

  constructor(wrapper, predictionCallback) {
    this.wrapper = wrapper;
    this.predictionCallback = predictionCallback;
  }

  init = async () => {
    console.log('Handling model Texts');
    await this.initDefaultValueMap();
  }

  initDefaultValueMap = async () => {
    const newState = { ...STATE };

    await tf.ready();
    newState.model = window.textFeatureExtractor;
    await newState.model.init();
    this.state = newState;
  }

  classify = async (textToClassify) => {
    if (this.model && this.predictionCallback) {
      const text = preprocessText(textToClassify);
      const results = {};
      this.predictionCallback(results);
      const embedding = await this.state.model.embed([text]);
      const prediction = this.model.predict(tf.tensor1d(embedding[0]).reshape([1, this.state.model.size]));

      const values = prediction.dataSync();
      for (let i = 0; i < values.length; i += 1) {
        Object.keys(this.samples).forEach((key) => {
          if (this.samples[key].index === i) {
            results[this.samples[key].name] = parseFloat(values[i].toFixed(4))
          }
        });
      }

      prediction.dispose();
      this.predictionCallback(results);
    }
  }

  startMedia = async () => { }

  stopMedia = () => {
    if (this.predictionCallback && this.classifying) {
      this.predictionCallback({});
      this.classifying = false
    }
  }

  clearAllSamples = () => {
    this.classifying = false;
    this.samples = {};
    this.model = null;
  }

  startClassifying = () => {
    if (this.predictionCallback) {
      this.predictionCallback({});
    }
    return setTimeout(() => {
      const wrapperElement = document.getElementById(this.wrapper);
      if (!wrapperElement) {
        console.error(`Element with ID '${this.wrapper}' not found.`);
        return;
      }

      const addSamplesContainer = document.createElement('div');
      addSamplesContainer.id = 'addSamplesContainer';

      const inputField = document.createElement('input');
      inputField.type = 'text';
      inputField.placeholder = 'Ingresar texto para clasificar';
      inputField.id = 'sampleInput';
      inputField.className = 'sampleInput';

      const addButton = document.createElement('button');
      addButton.textContent = 'Clasificar';

      const handleAddInputValue = (inputValue) => {
        if (inputValue) {
          this.classify(inputValue);
          inputField.value = '';
          inputField.focus();
        }
      }

      inputField.onkeydown = (event) => {
        if (event.key === 'Enter') {
          const inputValue = inputField.value.trim();
          handleAddInputValue(inputValue);
        }
      };

      addButton.onclick = () => {
        const inputValue = document.getElementById('sampleInput').value.trim();
        handleAddInputValue(inputValue);
      };

      wrapperElement.innerHTML = '';
      addSamplesContainer.appendChild(inputField);
      addSamplesContainer.appendChild(addButton);
      wrapperElement.appendChild(addSamplesContainer);
      inputField.focus();
    }, 100);
  }

  stopClassifying = () => {
    this.classifying = false;
  }

  setTrainingParams = (params) => {
    this.trainingParams = {
      ...this.trainingParams,
      ...params,
    };
  }

  getTrainingParams = () => {
    return this.trainingParams;
  }

  getMinSamplesRequired = () => {
    return this.minSamplesRequired;
  }

  addClass = (className = '') => {
    const classIndex = Object.keys(this.samples).length || 0;
    this.samples[`class${classIndex}`] = {
      index: classIndex,
      name: className,
      image: [],
      active: true,
      tensors: [],
    }
    this.updateModelMetadata()
  }

  editClassName = (id, name) => {
    if (this.samples[id]) {
      this.samples[id].name = name
      this.updateModelMetadata()
    } else {
      console.error(`Sample with id ${id} not found.`)
    }
  }

  deleteClass = (id) => {
    if (this.samples[id]) {
      delete this.samples[id];

      let i = 0;
      Object.keys(this.samples).map((sample) => {
        this.samples[sample].index = i;
        i += 1;
        return null;
      });
      this.updateModelMetadata();
    } else {
      console.error(`Sample with id ${id} not found.`)
    }
  }

  deleteSampleImages = (id, indexes) => {
    if (this.samples[id]) {
      this.samples[id].image = this.samples[id].image.filter((_, index) => !indexes.includes(index))
      this.samples[id].tensors = this.samples[id].tensors.filter(
        (_, index) => !indexes.includes(index),
      )
    } else {
      console.error(`Sample with id ${id} not found.`)
    }
  }

  addSample = async (className, text) => {
    if (className && text) {
      if (this.samples[className].image.includes(text)) {
        // console.log("Sample already exists in the class")
        return this.samples[className].tensors.length || 0
      }
      const sample = preprocessText(text)

      this.samples[className] = {
        ...this.samples[className],
        image: [...this.samples[className].image, sample],
      }

      return this.samples[className].tensors.length || 0
    }
    return 0
  }

  getSamples = () => {
    return { ...this.samples }
  }

  importSamples = (samples) => {
    if (Object.keys(samples).length > 0) {
      this.samples = samples;
    }
  }

  prepare = async () => {
    if (this.state.model) {
      for (const classes in this.samples) {
        if (classes.length === 0) {
          throw new Error('Add some examples before training')
        }
      }
      let trainDataset = []
      const labelDataset = []
      const sampleKeys = Object.keys(this.samples)
      for (let i = 0; i < sampleKeys.length; i += 1) {
        const key = sampleKeys[i]
        trainDataset = trainDataset.concat(
          this.samples[key].image.filter((item) => typeof item === 'string'),
          [],
        )
        for (let j = 0; j < this.samples[key].image.length; j += 1) {
          labelDataset.push(i)
        }
      }
      const embeddings = await this.state.model.embed(trainDataset)
      this.trainDataset = tf.tensor(embeddings)
      this.labelDataset = tf.oneHot(
        tf.tensor1d(labelDataset, 'int32'),
        Object.keys(this.samples).length,
      )

      const shuffledIndices = shuffleWithSeed(this.trainDataset.shape[0], 42) // Use a fixed seed
      const indicesTensor = tf.tensor1d(shuffledIndices, 'int32')
      this.trainDataset = this.trainDataset.gather(indicesTensor)
      this.labelDataset = this.labelDataset.gather(indicesTensor)
      indicesTensor.dispose()
    }
  }

  train = async (callbacks) => {
    await this.prepare();
    const classNamesLength = Object.keys(this.samples).length

    // const callbacks = {};
    // callbacks.onTrainEnd = (logs) => {
    //   console.log('==========onTrainEnd', logs);
    // };
    // callbacks.onEpochBegin = (epoch, logs) => {
    //   console.log('==========onEpochBegin', epoch, logs);
    // };
    // callbacks.onEpochEnd = (epoch, logs) => {
    //   console.log('==========onEpochEnd', epoch, logs);
    // };

    this.model = tf.sequential();
    this.model.add(tf.layers.dense({
      inputShape: [this.state.model.size],
      units: parseInt(this.trainingParams.denseUnits, 10),
      activation: 'sigmoid',
    }));

    // this.model.add(tf.layers.dropout({
    //   rate: 0.5,
    // }));

    this.model.add(tf.layers.dense({
      units: classNamesLength,
      activation: 'sigmoid',
    }));

    this.updateModelMetadata()

    const optimizer = tf.train.adam(parseFloat(this.trainingParams.learningRate));
    this.model.compile({
      optimizer,
      loss: 'meanSquaredError', // 'categoricalCrossentropy',
      metrics: ['accuracy'],
    });

    if (!(parseInt(this.trainingParams.batchSize, 10) > 0)) {
      throw new Error('Batch size is 0 or NaN. Please choose a non-zero fraction');
    }

    await this.model.fit(this.trainDataset, this.labelDataset, {
      epochs: parseInt(this.trainingParams.epochs, 10),
      batchSize: parseInt(this.trainingParams.batchSize, 10),
      validationSplit: 0.2,
      shuffle: true,
      callbacks,
      // classWeight: this.classWeights,
    });

    optimizer.dispose();
    this.trainDataset.dispose();
    this.labelDataset.dispose();

    return this.model;
  }

  saveModelToDB = async () => {
    // Get model JSON and weights data for database storage
    let modelJson = null;
    let modelWeights = null;

    const handlerToSave = async (artifacts) => {
      // artifacts contains all necessary model data including weightSpecs
      modelJson = {
        modelTopology: artifacts.modelTopology,
        weightsManifest: artifacts.weightsManifest,
        weightSpecs: artifacts.weightSpecs, // Include weight specifications
        format: artifacts.format,
        generatedBy: artifacts.generatedBy,
        convertedBy: artifacts.convertedBy,
        userDefinedMetadata: artifacts.userDefinedMetadata,
      };

      modelWeights = artifacts.weightData;

      return {
        modelArtifactsInfo: {
          dateSaved: new Date(),
          modelTopologyType: 'JSON',
          modelTopologyBytes: JSON.stringify(modelJson).length,
          weightSpecsBytes: artifacts.weightSpecs ? JSON.stringify(artifacts.weightSpecs).length : 0,
          weightDataBytes: modelWeights ? modelWeights.byteLength : 0,
        },
      };
    };

    await this.model.save(tf.io.withSaveHandler(handlerToSave));

    return {
      json: JSON.stringify(modelJson),
      weights: modelWeights, // This is an ArrayBuffer
      weightsBase64: modelWeights ? btoa(uint8ToString(new Uint8Array(modelWeights))) : null,
    };
  }

  loadModelFromDB = async (json, weights) => {
    const modelData = JSON.parse(json);
    const weightData = atob(weights);
    const weightBuffer = Uint8Array.from(weightData, c => c.charCodeAt(0)).buffer;

    // Include all necessary model artifacts including weightSpecs
    const modelArtifacts = {
      modelTopology: modelData.modelTopology,
      weightsManifest: modelData.weightsManifest,
      weightSpecs: modelData.weightSpecs, // Include weight specifications
      weightData: weightBuffer,
      format: modelData.format,
      generatedBy: modelData.generatedBy,
      convertedBy: modelData.convertedBy,
      userDefinedMetadata: modelData.userDefinedMetadata,
    };

    this.model = await tf.loadLayersModel(tf.io.fromMemory(modelArtifacts));
    if (this.model) {
      this.classNamesToIndex = this.model.getUserDefinedMetadata().classNames;
      return this.classNamesToIndex;
    } else {
      return false;
    }
  }

  loadModel = async (json, weights) => {
    this.model = await tf.loadLayersModel(`${this.importModelApi}/${json}/${weights}/model.json`);
    if (this.model) {
      this.classNamesToIndex = this.model.getUserDefinedMetadata().classNames;
      return this.classNamesToIndex;
    } else {
      return false;
    }
  }

  updateModelMetadata = () => {
    if (this.model) {
      const classNamesToIndex = {}
      for (const sample of Object.values(this.samples)) {
        classNamesToIndex[sample.name || sample] = sample.index
      }
      this.model.setUserDefinedMetadata({ classNames: classNamesToIndex })
    }
  }
}
